import { useMutation } from '@tanstack/react-query';
import { TodoIntegrationType } from '@demind-inc/core';

import { tasksApi, TodoTasksWebhookSubscribeReq } from '../api';

export type TodoWebhookProvider = Extract<TodoIntegrationType, 'clickup' | 'github' | 'trello'>;

interface SubscribeTodoWatchParams extends TodoTasksWebhookSubscribeReq {
  provider: TodoWebhookProvider;
}

export const useSubscribeTodoWatch = () => {
  const mutation = useMutation({
    mutationFn: async ({ todoTasksBoardIds, provider, userId }: SubscribeTodoWatchParams) => {
      const payload: TodoTasksWebhookSubscribeReq = {
        todoTasksBoardIds,
        userId,
      };

      if (provider === 'github') {
        return tasksApi.subscribeGithubBoardWebhook(payload).then((response) => response.data);
      } else if (provider === 'clickup') {
        return tasksApi.subscribeClickUpBoardWebhook(payload).then((response) => response.data);
      } else if (provider === 'trello') {
        return tasksApi.subscribeTrelloBoardWebhook(payload).then((response) => response.data);
      }
    },
  });

  return {
    subscribeTodoWatch: mutation.mutateAsync,
    ...mutation,
  };
};
